/* eslint-disable */
let self;
let page_path;
let form_name;
let form_id;
let form_type;
let form_variant;
let service_location;
let step_name;
let step;
let url_params;
let get_datalayer;
let user_email;
let user_id;
let event;

export class DataLayer_form {
  constructor(datalayer_attr) { // Receive part of the attributes to create the datalayer
    self = this;
    // Store the received data in local variables
    page_path = datalayer_attr.page_path ?? window.location.href;
    form_name = datalayer_attr.form_name;
    form_id = datalayer_attr.form_id;
    form_type = datalayer_attr.form_type;
    form_variant = datalayer_attr.form_variant;
    service_location = datalayer_attr.service_location;
    step_name = datalayer_attr.step_name;
    step = datalayer_attr.step;
    user_email = datalayer_attr.user_email;
    event = datalayer_attr.event;


    self.getDatalayerAttr();

    const datalayer = {
      event: event,
      form_name: form_name,
      form_id: form_id,
      form_type: form_type,
      form_variant: form_variant,
      service_location: service_location,
      step_name: step_name,
      step: step,
      user: {}
    };

    self.getDatalayerExtraAttr(datalayer, datalayer_attr.options);

    // Create and push the datalayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(datalayer);

  }

  // Define the other attributes based on the ones received by the constructor
  getDatalayerAttr() {

    if ((step !== '2') || (form_id === 'gform_178') || (form_id === 'gform_179')) {
      if (!form_name) {
        get_datalayer = dataLayer.find(function (obj) {
          return obj.event === "data_ready"
        });
        form_name // Construct the form name with values from de data_ready datalayer
          = get_datalayer.page.page_title + ' - '
          + get_datalayer.content_group + ' '
          + get_datalayer.content_type;
      }
      localStorage.setItem('form_name_key', form_name); // store the name to return in the "thank you" page
    } else {
      form_name = localStorage.getItem('form_name_key');
    }

    if ((!form_id) && (form_type === 'aside') && (step !== '2')) {
      if (page_path.indexOf('/codelab/') >= 0) {
        form_id = 'gform_64';
        form_variant = 'contact_info';
      } else if (page_path.indexOf('/webinar-deelname/') >= 0) {
        form_id = 'gform_81';
        form_variant = 'consultation';
      } else { // React forms without id
        const page_sub_path = page_path.split('/');
        form_id = page_sub_path[3];
        if(!form_variant) {
          form_variant = 'consultation';
        }
      }
    } else if (form_type === 'full_page') {
      if (page_path.indexOf('/formulier-huiswerkbegeleiding/?addproduct=') >= 0) {
        // Get the current url parameters
        url_params = new URLSearchParams(window.location.search); // Create object with values from the query strings
        form_id = url_params.get('addproduct');
        localStorage.setItem('form_id_key', form_id); // store the id to return in the "thank you" page
        form_variant = 'registration';
        service_location = $('.checkout-list__product-title').text(); // get the selected location text
        service_location = service_location.replace('\n                        Huiswerkbegeleiding ', '')
          .replace('\n                    ', '');
        localStorage.setItem('service_location_key', service_location); // store the location to return in the "thank you" page
        if (step === '0') {
          step_name = 'your_request';
        } else if (step === '1') {
          step_name = 'add_information';
        }
      } else if (page_path.indexOf('/formulier-bijles/?addproduct=') >= 0) {
        // Get the current url parameters
        url_params = new URLSearchParams(window.location.search); // Create object with values from the query strings
        form_id = url_params.get('addproduct');
        localStorage.setItem('form_id_key', form_id); // store the id to return in the "thank you" page
        form_variant = 'registration';
        service_location = $('.checkout-list__product-title').text(); // get the selected location text
        service_location = service_location.replace('\n                        Bijles ', '')
          .replace('\n                    ', '');
        localStorage.setItem('service_location_key', service_location); // store the location to return in the "thank you" page
        if (step === '0') {
          step_name = 'your_request';
        } else if (step === '1') {
          step_name = 'add_information';
        }
      } else if (page_path.indexOf('/informatiepakket-aanvragen/?') >= 0) {
        // Get the current url parameters
        url_params = new URLSearchParams(window.location.search); // Create object with values from the query strings
        if (url_params.get('dienst')) {
          form_id = url_params.get('dienst');
        } else {
          form_id = $('#js-info-product').find(":selected").first().text(); // get the selected option value
        }
        service_location = $('#js-info-location').find(":selected").text(); // get the selected option value
        service_location = service_location.replace('  ', '')
          .replace('\n                                                ', ' ')
          .replace('\n                                            ', '');
        // store the id and service_location for the thank you page
        localStorage.setItem('form_id_key', form_id);
        localStorage.setItem('service_location_key', service_location);
        form_variant = 'sign_up';
        if (step === '0') {
          step_name = 'request';
        } else if (step === '1') {
          step_name = 'first_interaction';
        }
      } else if (page_path.indexOf('/online-bijles/formulier-online-bijles/') >= 0) {
        form_id = 'online-bijles-aanmelden-form';
        if (step === '0') {
          step_name = 'your_request';
        } else if (step === '1') {
          step_name = 'add_information';
        }
      } else if ((page_path.indexOf('/contact/formulier/') >= 0) && (step === '1')) {
        step_name = 'first_interaction';
      }
    }
  }

  // Define the extra attributes
  getDatalayerExtraAttr(datalayer, options) {
    if ( options ) {
      datalayer.options = {};
      datalayer.options = options;
    }

    if (step === '2' && user_email) {
      datalayer.user.user_hashed_email = user_email;
    }

    // Set user id to localStorage key if set, else get it via ajax
    user_id = window.localStorage.getItem('user_id');
    if (!user_id) {
      // set user_email if user_email is set, else pick it up from the local storage
      user_email = user_email ?? window.localStorage.getItem('user_email_key');
      if (user_email) {
        $.ajax({
          url: ajax_link,
          method: 'post',
          async: false, // fix for put values in variables
          data: {
            action: 'lyceo_hash',
            nonce: ajax_nonce,
            string: user_email,
          },
        }).done(function (data) {
          user_id = data;
          window.localStorage.setItem('user_id', user_id);
        });
      }
    }
    // Set user_id in the datalayer
    if (user_id) {
      datalayer.user.user_id = user_id;
    }
  }
}
